export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'EMPLOYEES'        : {
                'TITLE': 'Employees'
            }
        }
    }
};
